import { useContext } from "react";

import { CartContext } from "../../contexts/cart.context";
import { PopupContext } from "../../contexts/popup.context";

import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";
import PopupProduct from "../Product-popup/product-popup.component";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  ProductCartContainer,
  Footer,
  Name,
  Price,
  ImgBox,
} from "./product-card.styles";

const ProductCard = ({ product }) => {
  const { name, price, imageUrl, id } = product;
  const { addItemToCart } = useContext(CartContext);
  const { isPopupOpen, setIsPopupOpen, addItemToPopup, popupObject } =
    useContext(PopupContext);

  const addProductToCart = () => {
    addItemToCart(product);
    toast.success("Product has been added to your cart!");
  };

  // passing prop through context to popup
  const changePopupState = () => {
    setIsPopupOpen(!isPopupOpen);
    addItemToPopup(product);
  };

  return (
    <>
      <ProductCartContainer>
        <ImgBox src={imageUrl} alt={`${name}`} onClick={changePopupState} />
        <Button
          buttonType={BUTTON_TYPE_CLASSES.inverted}
          onClick={addProductToCart}
        >
          Add to cart
        </Button>
        <Footer>
          <Name>{name}</Name>
          <Price>${price}</Price>
        </Footer>
        {isPopupOpen && id === popupObject.id && <PopupProduct key={id} />}
        <ToastContainer />
      </ProductCartContainer>
    </>
  );
};

export default ProductCard;
